import type { AuthRepository, ResetPasswordPayload } from '@core/repositories/AuthRepository';

export class ResetPasswordUseCase {
  private readonly authRepository: AuthRepository;

  constructor(authRepository: AuthRepository) {
    this.authRepository = authRepository;
  }

  execute(payload: ResetPasswordPayload): Promise<void> {
    return this.authRepository.resetPassword(payload);
  }
}
